import * as React from 'react'

function SvgIconMenu3DotsV(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="menu-3-dots-v" aria-labelledby="t-menu-3-dots-v d-menu-3-dots-v">
        <title id="t-menu-3-dots-v">{'Menu 3 dots vertical'}</title>
        <desc id="d-menu-3-dots-v">{'3 dots in vertical row'}</desc>
        <circle cx={16} cy={28} r={4} />
        <circle cx={16} cy={16} r={4} />
        <circle cx={16} cy={4} r={4} />
      </g>
    </svg>
  )
}

export default SvgIconMenu3DotsV
